import styled from 'styled-components';

export const ContentContainer = styled.div`
  margin: 0 auto;
  max-width: 1280px;
`;
